<div>
    <div class="workorder-toolbar">
        <div class="container-xl">
            <div class="toolbar">
                <div class="toolbar-content">
                    <i class="fa fa-arrow-left" routerLink="/{{Routenames.Projects}}/{{Routenames.Map}}"
                       matTooltip="Terug naar projectenkaart" matTooltipPosition="below"></i>

                    <h1>Werkopdrachten</h1>
                </div>
                <div class="toolbar-content filters">
                    <div class="toggle">
                        <mat-slide-toggle [formControl]="form.controls.remark">
                            Met opmerkingen
                        </mat-slide-toggle>
                    </div>
                    @if (Features.WorkordersShowIncomplete | hasFeature) {
                        <div class="toggle">
                            <mat-slide-toggle [formControl]="form.controls.incomplete">
                                {{form.controls.incomplete.value ? 'Alles' : 'Incompleet'}}
                            </mat-slide-toggle>
                        </div>
                    }
                    <div class="toggle">
                        <mat-slide-toggle [formControl]="form.controls.history">{{form.controls.history.value ? 'Actueel' : 'Historie'}}</mat-slide-toggle>
                    </div>
                    @if (Features.WorkordersAccessAny | hasFeature) {
                        <ng-select
                            appearance="fill"
                            bindLabel="name"
                            bindValue="id"
                            placeholder="Selecteer werkvoorbereider"
                            [formControl]="form.controls.userId"
                            [virtualScroll]="true">
                            <ng-option *ngFor="let manager of managers" [value]="manager.id">
                                {{manager.name ?? manager.id_4ps}}
                            </ng-option>
                        </ng-select>
                    }

                    <mat-form-field class="flex-grow-1">
                        <input matInput
                               [formControl]="form.controls.search"
                               name="search"
                               placeholder="Zoek werkopdracht"
                               type="text">
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>

    <div class="workorders ">
        <div class="container-xl">
            <div *ngIf="!workorders">
                Werkopdrachten worden geladen...
            </div>
            <div *ngIf="workorders?.length === 0">
                Er zijn geen werkopdrachten gevonden.
                @if (form.value.userId) {
                    Je ziet alleen de werkopdrachten waarvoor {{(managers | byId : form.value.userId)?.name}} de uitvoerder is.
                }
            </div>
        </div>
        @for (workorder of workorders; track $index) {
            <div class="container-xl workorder-line" [class.past]="workorder.planned_enddate | isDateBefore">
                <a class="workorder" routerLink="/{{Routenames.WorkOrders}}"
                   [queryParams]="{workorderId: workorder.id}">
                    <div class="workorder-content">
                        <div class="workorder-info">
                            <h1 class="title">{{workorder.project?.id_4ps}}</h1>
                            <h2 class="subtitle">{{workorder.source_no}}</h2>
                            <h2 class="subtitle">{{workorder.id_4ps}}</h2>
                        </div>
                        <div class="workorder-info">
                            <app-codalt-chip [text]="workorder.drawings_count ?? 0"
                                             icon="paperclip"
                                             [error]="workorder.drawings_count == 0 && workorder.ttms_count== 0"></app-codalt-chip>
                            <app-codalt-chip [text]="workorder.drawings_with_drawing_count ?? 0"
                                             icon="map-location-dot"
                                             [error]="workorder.drawings_with_drawing_count == 0 && workorder.ttms_count == 0"></app-codalt-chip>
                            <app-codalt-chip text="{{workorder?.ttms_mutated_count}} / {{workorder?.ttms_count}}"
                                             icon="traffic-cone"
                                             [error]="workorder.ttms_count == 0"></app-codalt-chip>
                            <app-codalt-chip text="{{workorder?.ttms_with_comment_count}} / {{workorder?.ttms_count}}"
                                             icon="comments"
                                             class="cursor-pointer"
                                             matRipple
                                             (click)="openWithRemarkFilter($event, workorder)"
                                             [error]="workorder.ttms_with_comment_count > 0"></app-codalt-chip>
                        </div>
                    </div>
                    <div class="workorder-content">
                        <div class="workorder-info">
                            <h2 class="title">{{workorder.project?.name}}</h2>
                            <p class="description">{{workorder.name}}</p>
                        </div>
                        <div class="workorder-info">
                            <p *ngIf="workorder.started_date && !workorder.finished_date" class="started time">
                                <i class="fa fa-play"></i>{{workorder.started_date | codaltDate : 'EEEE d MMMM yyyy H:mm'}}
                            </p>

                            <p *ngIf="workorder.started_date && workorder.finished_date" class="finished time">
                                <i class="fa fa-check"></i>{{workorder.started_date | codaltDate : 'EEEE d MMMM yyyy H:mm' : workorder.finished_date}}
                            </p>
                            <p class="time">
                                {{workorder.planned_startdate | codaltDate : 'EEEE d MMMM yyyy H:mm' : workorder.planned_enddate}}
                            </p>
                            <h2 class="title">
                                {{workorder.soort}}
                            </h2>
                        </div>
                    </div>

                    <div class="workorder-content">
                        <div class="workorder-info">
                            @if (form.value.userId !== workorder.project?.projectmanager_id) {
                                <app-codalt-chip [text]="workorder.project?.projectmanager?.name || 'Geen uitvoerder aan deze werkopdracht gekoppeld'"
                                                 [error]="!workorder.project?.projectmanager" [dark]="true"></app-codalt-chip>
                            }
                            @if (Features.ShowSensetiveInformation | hasFeature) {
                                @for (user of workorder.users; track $index) {
                                    <app-codalt-chip [text]="user?.name || '?'" [light]="true"></app-codalt-chip>
                                } @empty {
                                    <app-codalt-chip text="Geen medewerkers aan deze werkopdracht gekoppeld." [light]="true"></app-codalt-chip>
                                }
                            }
                        </div>
                    </div>
                </a>
            </div>
        }
    </div>
</div>
